import React from "react";
import { createPortal } from "react-dom";

type ConfirmDialogProps = {
  open: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
};

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  message,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* backdrop */}
      <div className="absolute inset-0 bg-black/40" onClick={onCancel}></div>

      {/* dialog */}
      <div className="relative z-10 w-[380px] rounded-lg bg-white p-6 shadow-lg">
        <p className="text-center text-[18px] font-medium text-gray-800 mb-6">
          {message}
        </p>

        <div className="flex justify-center gap-4">
          <button
            className="min-w-[100px] rounded bg-gray-200 px-4 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-300"
            onClick={onCancel}
          >
            NO
          </button>
          <button
            className="min-w-[100px] rounded bg-[#1E5BFF] px-4 py-2 text-sm font-semibold text-white hover:opacity-90"
            onClick={onConfirm}
          >
            YES
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmDialog;
